import styled from 'styled-components';
import { Page } from '../../components/Layout';

export const DocumentCategory = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    min-height: auto;
  }
`;

export const DocumentPage = styled(Page)`
  @media screen and (-ms-high-contrast: active) {
    margin-bottom: 3em;
  }

  @media screen and (max-width: 800px){
    min-height: 800px !important;
  }

  @media screen and (max-width: 350px){
    max-width: 750px;
      align-self:center;
      width: 100%;
      padding-left: 1.2em;
      padding-right: 0.2em;
      padding-bottom: 7em;
  }
`;

export const SeachableDropdownWrapper = styled.div`
  @media screen and (max-width: 500px){
    width: 110%;
  }

  @media screen and (max-width:343px){
    width: 103%;
  }
 `;
